module.exports = __webpack_public_path__ + "static/media/nodejs.521444a2.png";